import { render, staticRenderFns } from "./ManageMissionTypes.vue?vue&type=template&id=228b54fe&"
import script from "./ManageMissionTypes.vue?vue&type=script&lang=js&"
export * from "./ManageMissionTypes.vue?vue&type=script&lang=js&"
import style0 from "./ManageMissionTypes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports